import { Address} from '../associates/address.model';
import { Associate } from '../associates/associate.model';
export class AssociateReport {
  active: string = null;
  addressLine1: string = null;
  addressLine2: string = null;
  addressLine3: string = null;
  associateType: string = null;
  cellPhoneNumber: string = null;
  classId: string = null;
  contactMethodUpdatedDate: Date = null;
  contactPreferenceId: string = null;
  conversionControlNumber: string = null;
  conversionId: string = null;
  countryId: string = null;
  countyId: number = null;
  countyName: string = null;
  createdDate: Date = null;
  embedded?: AssociateReportEmbed = null;
  electricCardReader: string = null;
  emailAddress: string = null;
  emailConsent: string = null;
  firstName: string = null;
  fullName: string = null;
  homePhoneNumber: string = null;
  id?: string = null;
  initialContactMethod: string = null;
  lastName: string = null;
  legalFirstName: string = null;
  legalLastName: string = null;
  legalName: string = null;
  legalNameFlag: string = null;
  locationId: string = null;
  locationName: string = null;
  loyaltyNumber: string = null;
  mailingAddressSequence: number = null;
  messagePreferenceId: number = null;
  nameAddress: string = null;
  openProspects: number = null;
  position: string = null;
  postalZipCode: string = null;
  provStateId: string = null;
  privacyLevelId: number = null;
  rowId: number = null;
  sequence: number = null;
  subTypeId: string = null;
  textConsent: string = null;
  vehicleCount: number = null;
  webAddress: string = null;
  workPhoneNumber: string = null;

  constructor(obj?: AssociateReport) {
    if (obj) {
      Object.assign(this, obj);
    }
  }
}

class AssociateReportEmbed {
  addresses?: Address = null;
  associate?: Associate = null;
}
